import { AuthenticateWithRedirectCallback } from '@clerk/clerk-react'
import { AuthLayout } from '@/components/auth/AuthLayout'
import { ROUTES } from '@/routes/routes'

/** Lands here after Google redirects back from its consent screen. Clerk's documented classic
 *  pattern — completes the OAuth flow and navigates on its own. Without explicit fallback URLs,
 *  Clerk defaults every one of these sub-cases to its own hosted Account Portal
 *  (accounts.dev/sign-in) rather than our app:
 *  - the user cancels/denies at Google's screen (falls back to signInUrl)
 *  - Google didn't supply a name and "Name" is required on the Clerk instance, leaving the
 *    sign-up incomplete (falls back to continueSignUpUrl — SignUpPage's 'finish-google' step
 *    picks this up via signUp.missingFields)
 *  - the flow completes — signInFallbackRedirectUrl/signUpFallbackRedirectUrl both default to
 *    '/' (home page) if unset. A first-time Google sign-IN gets fulfilled as an account
 *    creation internally (there's no separate "sign up" step for a new OAuth identity), so it's
 *    the sign-up fallback that actually applies here even though the user clicked the button on
 *    the sign-in page — RequireHousehold (wrapping /app/dashboard) is what then correctly routes
 *    a brand-new user with no household on to onboarding.
 *  Recording the session (audit trail) doesn't happen here: this page's lifetime is
 *  unpredictable, so that's handled by <PendingSessionRecorder/> at the app root instead, via
 *  sessionStorage — see markPendingSignInMethod() in SignInPage/SignUpPage's Google buttons. */
export default function SSOCallbackPage() {
  return (
    <AuthLayout title="Signing you in" subtitle="Just a moment…">
      <AuthenticateWithRedirectCallback
        signInUrl={ROUTES.AUTH.SIGN_IN}
        signUpUrl={ROUTES.AUTH.SIGN_UP}
        continueSignUpUrl={ROUTES.AUTH.SIGN_UP}
        signInFallbackRedirectUrl={ROUTES.APP.DASHBOARD}
        signUpFallbackRedirectUrl={ROUTES.APP.DASHBOARD}
      />
    </AuthLayout>
  )
}
